import { SovosBox, SovosTypography } from "mosaic-react";
import React from "react";

const buildTranslationSyntax = (translation, startWord) => {
    return (translation || []).map((elem, index) => {
        const { column, operator, value } = elem;
        const cdmNameSplitted = column.split(".");
        const columnName = cdmNameSplitted?.length
            ? cdmNameSplitted[cdmNameSplitted.length - 1]
            : null;
        return (
            <React.Fragment key={index}>
                {index === 0 && (
                    <SovosTypography variant="body2" sx={{ marginRight: "5px" }}>
                        {startWord}
                    </SovosTypography>
                )}
                {index !== 0 && (
                    <SovosTypography variant="body2" sx={{ marginRight: "5px" }}>
                        and
                    </SovosTypography>
                )}
                {columnName && (
                    <>
                        <SovosTypography variant="body1" sx={{ marginRight: "5px" }}>
                            <strong>{columnName}</strong>
                        </SovosTypography>
                        <SovosTypography variant="body2" sx={{ marginRight: "5px" }}>
                            {operator}
                        </SovosTypography>
                        <SovosTypography variant="body1" sx={{ marginRight: "5px" }}>
                            <strong>{value}</strong>
                        </SovosTypography>
                    </>
                )}
            </React.Fragment>
        );
    });
};

export default function TranslationDetailsSyntaxRow(props) {
    const { value: cell } = props || {};
    const { conditionsParsed, updatesParsed } = cell;

    const conditionsComponents = buildTranslationSyntax(conditionsParsed, "When");
    const updateComponents = buildTranslationSyntax(updatesParsed, "convert");

    return (
        <SovosBox
            sx={{
                display: "flex",
                justifyContent: "space-around",
                alignItems: "center",
                padding: "10px",
            }}
        >
            {conditionsComponents}
            {updateComponents}
        </SovosBox>
    );
}
